/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Badge } from '@mantine/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown'
import { faEquals } from '@fortawesome/free-solid-svg-icons/faEquals'

export type PriorityBadgeProps = {
  priority: number
}

function PriorityBadge (props: PriorityBadgeProps) {
  const { priority, ...others } = props

  if (priority >= 1) {
    return (
      <Badge color="red" variant="outline" {...others}>
        <FontAwesomeIcon icon={faArrowUp} />
      </Badge>
    )
  }
  if (priority === 0) {
    return (
      <Badge color="orange" variant="outline" {...others}>
        <FontAwesomeIcon icon={faEquals} />
      </Badge>
    )
  }
  return (
    <Badge color="blue" variant="outline" {...others}>
      <FontAwesomeIcon icon={faArrowDown} />
    </Badge>
  )
}

export default PriorityBadge
